import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import { useAspectRatio } from '../../theme/common';
import toolStyles from './tools-styles';

function toolsCard(props) {
  const {
    src, title, description, uri
  } = props;
  const aspectRatio = useAspectRatio();
  const classes = toolStyles();
  return (
    <a href={uri || '#'} className={classes.mainLink}>
      <div className={clsx(aspectRatio.twentyOneByNine, classes.root)}>
        <div className={classes.cardInner}>
          <img src={src} alt="logo-img" className={classes.toolsImg} />
          <div className={classes.contentSection}>
            <Typography className={classes.title}>{title}</Typography>
            <Typography className={classes.description}>{description}</Typography>
          </div>
        </div>
      </div>
    </a>
  );
}

toolsCard.propTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  uri: PropTypes.string.isRequired
};

export default toolsCard;
